var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      {
        staticClass: "row",
        staticStyle: {
          "border-bottom": "1px solid #EEEEEE",
          padding: "0.5rem 0"
        }
      },
      [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("router-link", { attrs: { to: "/cleaner/" + _vm.id } }, [
              _c("div", { staticClass: "avatar-container small" }, [
                _c("div", {
                  class: [
                    "dot",
                    _vm.professional.active === 1 ? "active" : "inactive"
                  ]
                }),
                _vm._v(" "),
                _c("img", {
                  directives: [
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value: _vm.professional.picture,
                      expression: "professional.picture"
                    }
                  ],
                  staticClass: "rounded-circle message-user-img"
                })
              ]),
              _vm._v(
                "\n         " +
                  _vm._s(_vm._f("firstName")(_vm.professional.name)) +
                  "\n      "
              )
            ])
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fdcdf8be", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdcdf8be","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/CleanerDetailMobile.vue
// module id = 1912
// module chunks = 0